export default {
  welcome: "Welcome",
  login: "Login",
  register: "Register",
  logout: "Logout",
  domains: "Domains",
  status: "Status",
  search: "Search...",
  actions: "Actions",
  no_data: "No data",
  loading: "Loading…",
  date: "Date",
  event: "Event",
  view: "View",
  planes: "Plans",
  navigation: {
    context: "Context",
    platform_admin: "Platform administration",
    administration: "Administration",
    accounts: "Accounts",
    users: "Users",
    audit: "Audit",
    error_logs: "Error log",
    profile: "Profile",
    home: "Home",
    domains: "Domains",
    emails: "Emails",
    api_keys: "API keys",
    my_team: "My team",
    settings: "Settings",
    primary: "Primary navigation",
    open_menu: "Open navigation",
    close_menu: "Close navigation",
    collapse_menu: "Collapse navigation",
    expand_menu: "Expand navigation",
    my_account: "My account",
    my_profile: "My profile",
    configuration: "Configuration",
    billing: "Billing",
    notifications: "Notifications",
    avatar: "User avatar",
    default_avatar: "Default avatar",
    context_switch_error: "The context could not be changed.",
  },
  notifications: {
    title: "Notifications",
    description: "Invitations and updates for your account.",
    unread: "Unread",
    view_invitation: "View invitation",
    status: {
      accepted: "Accepted",
      revoked: "Revoked",
      expired: "Expired",
      unavailable: "Unavailable",
    },
  },
  team: {
    invitation: {
      created: "Team invitation created",
      accepted: "Team invitation accepted",
    },
    member: {
      added: "Team member added",
      role_changed: "Team member role changed",
      activated: "Team member activated",
      deactivated: "Team member deactivated",
      removed: "Team member removed",
    },
    settings: {
      updated: "Team settings updated",
    },
  },
  members: {
    title: "My team",
    description: "Manage team access. The owner is protected.",
    invite_title: "Invite member",
    email_placeholder: "user@example.com",
    add: "Add",
    invitation_expiry: "The link expires in 7 days and is shown only once.",
    copy_link: "Copy link",
    user: "User",
    role: "Role",
    membership: "Membership",
    since: "Since",
    owner: "Owner",
    administrator: "Administrator",
    member: "Member",
    active: "Active",
    inactive: "Inactive",
    activate: "Activate",
    deactivate: "Deactivate",
    protected: "Protected",
    no_role: "No role",
    unnamed: "Unnamed",
    operation_error: "The operation could not be completed.",
    invitation_created: "Invitation created successfully.",
    role_updated: "Role updated successfully.",
    status_updated: "Status updated successfully.",
    remove_title: "Remove member?",
    remove_confirm: "{email} will be removed from this account.",
    remove: "Remove",
    removed: "Member removed successfully.",
  },
  invitation: {
    eyebrow: "Team invitation",
    headline: "Your next workspace",
    headline_emphasis: "is waiting for you.",
    description: "Collaborate, manage domains, and monitor your sends from one place.",
    invited_by: "Invited by the team",
    protected: "Protected invitation linked to your email.",
    checking: "Checking invitation",
    checking_description: "We are checking that the link is still active.",
    ready: "All set",
    accepted_title: "You are now part of the team",
    accepted_description: "The invitation was accepted successfully. You can continue to your dashboard.",
    go_to_dashboard: "Go to dashboard",
    unavailable: "Link unavailable",
    open_error_title: "We could not open the invitation",
    join: "Join the team",
    accept_title: "Accept your invitation",
    confirm_details: "Confirm your details to join {team}.",
    invited_email: "Invited email",
    assigned_role: "Assigned role",
    available_until: "Available until",
    existing_account: "You already have an account",
    existing_account_hint: "Accept using the session for {email}.",
    accepting: "Accepting…",
    accept: "Accept invitation",
    first_name_placeholder: "Your first name",
    last_name_placeholder: "Your last name",
    password_placeholder: "At least 6 characters",
    hide_password: "Hide password",
    show_password: "Show password",
    creating_account: "Creating your account…",
    create_and_accept: "Create account and accept",
    terms: "By continuing, you will create an account linked to the invited email.",
    footer: "Email infrastructure for teams",
    default_expiration: "7 days after it was sent",
    login_required: "Sign in with the invited email and reopen this link.",
    accept_error: "The invitation could not be accepted. Please try again.",
    expired_error: "The link may have expired or may no longer be active.",
  },
  forbidden: {
    title: "Access denied",
    description: "You do not have permission to access this section.",
  },
  admin: {
    dashboard: {
      title: "Administration",
      subtitle: "Destinatarium global overview",
      view_users: "View users",
      view_accounts: "View accounts",
      active_accounts: "{count} active",
      last_seven_days: "{count} in the last 7 days",
    },
    accounts: {
      title: "Accounts",
      search: "Search accounts…",
      account: "Account",
      access: "Access",
      members: "Members",
      subscription: "Subscription",
      active: "Active",
      inactive: "Inactive",
      blocked: "Blocked",
      available: "Available",
      blocked_users: "{count} user | {count} users",
      view_attempts: "View login attempts",
      view_account: "View account",
      login_attempts: "Login attempts",
      close_history: "Close history",
      back: "Back to accounts",
      detail: "Account details",
      created_at: "Created on {date}",
      recipients: "Recipients",
      last_seven_days: "Last 7 days",
      status: "Status",
      no_subscription: "No subscription",
      provider: "Provider",
      plan_price: "Plan / price",
      next_renewal: "Next renewal",
      period_end: "Period end",
      email_usage: "Email usage",
      used_of: "of {limit}",
      quota_percentage: "Percentage of quota used",
      percent_used: "{percent}% used",
      available_count: "{count} available",
      quota_unconfigured: "This account's quota has not been configured yet.",
      period: "Period: {start} — {end}",
      users_roles: "Users and roles",
      account_roles: "Account roles",
      no_assigned_role: "No assigned role",
      no_users: "This account has no associated users.",
      not_found: "Account not found.",
      load_error: "The account could not be loaded.",
    },
    users: {
      title: "Users",
      search: "Name or email…",
      all_statuses: "All statuses",
      active_plural: "Active",
      inactive_plural: "Inactive",
      all_roles: "All roles",
      all_accounts: "All accounts",
      user: "User",
      access: "Access",
      roles: "Roles",
      accounts: "Accounts",
      created: "Created",
      active: "Active",
      inactive: "Inactive",
      blocked: "Blocked",
      available: "Available",
      no_roles: "No roles",
      no_account: "No account",
      view_user: "View user",
      unnamed: "Unnamed",
      back: "Back to users",
      email_verified: "Email verified",
      yes: "Yes",
      no: "No",
      information: "Information",
      phone: "Phone",
      last_access: "Last access",
      updated: "Updated",
      platform_roles: "Platform roles",
      no_platform_roles: "This user has no platform roles.",
      memberships_roles: "Memberships and roles",
      account_status: "Account status",
      membership: "Membership",
      since: "Since",
      no_role: "No role",
      no_accounts: "This user does not belong to any account.",
      recent_attempts: "Recent login attempts",
      last_ten: "Last 10",
      not_found: "User not found.",
      load_error: "The user could not be loaded.",
    },
    audit: {
      title: "Audit",
      filter_action: "Filter by action…",
      actor: "Actor",
      action: "Action",
      resource: "Resource",
    },
    error_logs: {
      title: "Error log",
      subtitle: "Incidents recorded by the platform",
      refresh: "Refresh",
      filters_label: "Error log filters",
      search: "Search by message, code, or source…",
      level: "Level",
      all_levels: "All levels",
      source: "Source",
      message: "Message",
      code: "Code",
      detail: "Details",
      show_detail: "View details",
      hide_detail: "Hide details",
      context: "Context",
      stack_trace: "Stack trace",
      unavailable: "Unavailable",
      levels: {
        critical: "Critical",
        error: "Error",
        warning: "Warning",
        info: "Information",
        debug: "Debug",
      },
    },
    emails: {
      title: "Emails",
      subtitle: "Deliveries from every platform account",
      refresh: "Refresh",
      filters_label: "Email filters",
      search: "Exact email, name, or subject…",
      search_hint: "Search uses exact matches to protect encrypted data.",
      all_accounts: "All accounts",
      all_statuses: "All statuses",
      message: "Message",
      route: "Sender / recipient",
      no_subject: "No subject",
      view_detail: "View email details",
      statuses: {
        scheduled: "Scheduled",
        sending: "Sending",
        sent: "Sent",
        delivered: "Delivered",
        delayed: "Delayed",
        bounced: "Bounced",
        failed: "Failed",
        outcome_unknown: "Outcome unknown",
        suppressed: "Suppressed",
        canceled: "Canceled",
        unknown: "Unknown",
      },
    },
    domains: {
      title: "Domains",
      subtitle: "Domains from every platform account",
      refresh: "Refresh",
      filters_label: "Domain filters",
      search: "Search domains…",
      all_accounts: "All accounts",
      all_statuses: "All statuses",
      domain: "Domain",
      created: "Created",
      pending: "Pending",
      active: "Active",
      unknown_status: "Unknown status",
    },
    common: {
      status: "Status",
      actions: "Actions",
      date: "Date",
      account: "Account",
      email: "Email",
      domains: "Domains",
      read_only: "Read only",
      deleted_user: "Deleted user",
      unknown: "Unknown",
    },
    attempts: {
      user: "User",
      result: "Result",
      success: "Successful",
      invalid_credentials: "Invalid credentials",
      rate_limited: "Blocked",
      blocked: "Blocked",
    },
  },
  roles: {
    platform_admin: "Platform administrator",
    team_owner: "Owner",
    team_admin: "Administrator",
    team_member: "Member",
  },
  list_state: {
    loading_users: "Loading users…",
    loading_accounts: "Loading accounts…",
    loading_events: "Loading events…",
    loading_error_logs: "Loading errors…",
    loading_admin_emails: "Loading emails…",
    loading_admin_domains: "Loading domains…",
    loading_members: "Loading members…",
    loading_notifications: "Loading notifications…",
    loading_statistics: "Loading statistics…",
    loading_account: "Loading account…",
    loading_user: "Loading user…",
    loading_attempts: "Loading attempts…",
    loading_billing: "Loading billing details…",
    empty_users: "No users to display.",
    empty_accounts: "No accounts to display.",
    empty_events: "No events.",
    empty_error_logs: "No errors to display.",
    empty_admin_emails: "There are no emails to display.",
    empty_admin_domains: "There are no domains to display.",
    empty_members: "No members.",
    empty_notifications: "You have no notifications.",
    empty_attempts: "No attempts have been recorded.",
    error_users: "Users could not be loaded.",
    error_accounts: "Accounts could not be loaded.",
    error_events: "The audit log could not be loaded.",
    error_error_logs: "The error log could not be loaded.",
    error_admin_emails: "Emails could not be loaded.",
    error_admin_domains: "Domains could not be loaded.",
    error_members: "Members could not be loaded.",
    error_notifications: "Notifications could not be loaded.",
    error_statistics: "The summary could not be loaded.",
    error_attempts: "Login attempts could not be loaded.",
  },
  pagination: {
    items: "{count} items",
    showing: "Showing",
    of: "of",
    records: "records",
    rows: "Rows",
    previous: "Previous",
    page: "Page",
    next: "Next",
    per_page: "{count} per page",
  },
  auth_local: {
    recover: "Recover password",
    reset: "Save new password",
    google: "Continue with Google",
    link_google: "Link Google",
    google_pending: "Google sign-in is currently unavailable.",
    recover_email_hint: "If the account exists, you will receive an email with a link to reset your password.",
    refresh: "Refresh mailbox",
    mailbox: "Local test mailbox",
    mailbox_hint: "Emails are captured here, not sent. The mailbox is cleared when the server restarts.",
    mail_verification: "Verify email",
    mail_reset: "Reset password",
    callback: "Redirect URI to configure in Google Cloud:",
    recover_hint: "If the account exists, the link will appear in the local mailbox.",
    reset_done: "Password updated. You can now sign in.",
    oauth_error: "Google sign-in was not completed: {error}. Return to sign-in and try again.",
    oauth_account_not_linked: "We could not link Google to your account. Check that Google has verified your email, or sign in with your password to link it.",
    callback_title: "Completing Destinatarium sign-in",
    onboarding_title: "Complete your profile",
    onboarding_hint: "We need your first and last name to complete your account and team registration.",
    complete: "Complete registration",
    database: "Local database",
  },
  auth: {
    tagline_start: "This is how",
    tagline_emphasis: "sending email should feel.",
    description:
      "Fast, reliable, and easy-to-use transactional email infrastructure.",
    reliable_delivery: "Reliable delivery",
    reliable_delivery_description: "More inbox, less spam",
    fast_api: "Fast API",
    fast_api_description: "Integrate in minutes",
    security_first: "Security first",
    security_first_description: "We protect your data",
    welcome_back: "Welcome back",
    login_subtitle: "Enter your credentials to continue",
    no_account: "Don't have an account?",
    create_account: "Create account",
    register_subtitle: "Start sending emails today",
    already_have_account: "Already have an account?",
    logging_in: "Signing in…",
    login_failed: "Unable to sign in. Check your credentials and try again.",
    check_your_email: "Check your email",
    check_your_email_help: "We sent you a verification email. Open it and click the link to activate your account. The link expires in 24 hours.",
    verifying_email: "Verifying your email…",
    verifying_email_help: "We are validating your verification link.",
    confirm_email: "Confirm your email address",
    confirm_email_help: "Press the button to complete your account verification.",
    confirm_email_button: "Confirm my email",
    email_verified: "Email verified",
    email_verified_help: "Your account is active. You can now sign in.",
    verification_failed: "We could not verify your email",
    verification_failed_help: "The link is invalid or expired. Request a new one.",
    resend_verification: "Resend verification email",
    sending_verification: "Sending…",
    verification_resent: "Request processed successfully. If the account is pending, you will receive a new email.",
    verification_resend_failed: "We could not resend the email. Please try again.",
    back_to_login: "Back to sign in",
  },
  dashboard: {
    title: "Dashboard",
    welcome: "Great to see you again, {name}! 👋",
    trend_7d: "{value}% vs. 7 days",
    kpis: {
      domains: "Domains",
      emails: "Emails",
      pending_dns: "Pending DNS",
      approved: "Approved",
    },
    charts: {
      domains_by_status: "Domains by status",
      emails_by_status: "Emails by status",
      total: "Total",
    },
    status: {
      pending_dns: "Pending DNS",
      approved: "Approved",
    },
    guide: {
      title: "Send your first email",
      description: "Set up your account and make your first send in 5 steps.",
      progress: "{completed} of {total} complete",
      progress_label: "Setup progress",
      review: "Review",
      review_dns: "Review DNS",
      complete_title: "Setup complete!",
      complete_description: "Your account is ready and you have checked your first send.",
      status: {
        waiting_verification: "Awaiting verification",
        processing_delivery: "Processing the send",
        sent_waiting_delivery: "Sent; awaiting delivery confirmation",
        delivery_unconfirmed: "Delivery unconfirmed; review the result",
      },
      steps: {
        domain: {
          title: "Add a domain",
          description: "Choose the domain you will use as the sender.",
          action: "Add domain",
        },
        dns: {
          title: "Configure and verify DNS",
          description: "Publish the required records and wait for approval.",
          action: "Configure DNS",
        },
        api_key: {
          title: "Create an API key",
          description: "Generate the credential your application will use.",
          action: "Create API key",
        },
        test_email: {
          title: "Send a test email",
          description: "Make your first send from the verified domain.",
          action: "Send test",
        },
        result: {
          title: "Check the result",
          description: "Review the final status and confirm delivery.",
          action: "View results",
        },
      },
    },
    tip: {
      title: "Tip:",
      text: "Add more domains and start sending emails to see how your statistics change.",
      action: "Add domain",
    },
  },
  subscription: {
    plans: "Plans",
    subtitle: "Choose the plan that best supports your team's growth.",
    current_plan: "Current plan",
    month: "Month",
    year: "Year",
    monthly: "Monthly",
    yearly: "Yearly",
    billing_cycle: "Billing frequency",
    loading_plans: "Loading plans…",
    load_error: "We could not load the plans. Please try again.",
    retry: "Try again",
    no_active_plans: "No active plans are available.",
    most_used: "Most popular",
    custom_price: "Custom",
    processing_payment: "Waiting for secure payment confirmation…",
    scheduled_change: "A subscription change is scheduled.",
    scheduled_change_date: "A subscription change is scheduled for {date}.",
    checkout_unavailable_title: "Checkout unavailable",
    checkout_unavailable_text: "The payment configuration is unavailable.",
    cancel_title: "Cancel subscription?",
    cancel_text: "Your paid access will remain available until Paddle applies the scheduled cancellation.",
    continue: "Continue",
    confirm_change_title: "Confirm plan change",
    confirm_change_text: "Paddle will calculate this change using immediate proration. Any amount due may be collected now.",
    confirm_change: "Confirm change",
    billing_updated_title: "Billing updated",
    billing_updated_text: "Paddle confirmed the operation.",
    subscription_active_title: "Subscription active",
    subscription_active_text: "Your new plan is ready.",
    payment_received_title: "Payment received",
    payment_received_text: "Paddle is still confirming your subscription. The plan will activate automatically.",
    change_requested_title: "Change requested",
    change_requested_text: "The subscription will update when Paddle confirms the change.",
    custom_plan_contact_title: "Contact us",
    custom_plan_contact_message:
      "Email plans@destinatarium.com to discuss a custom plan.",
    plan_cycle_monthly_msg: "2 months free with yearly billing\u00A0🎁",
    plan_cycle_yearly_msg: "2 free months for you!\u00A0🎉",
    plan_names: {
      free: "Free",
      starter: "Starter",
      flow: "Flow",
      growth: "Growth",
      enterprise: "Enterprise",
    },
    plan_taglines: {
      free: "Get started",
      starter: "You're up and running",
      flow: "Things start flowing",
      growth: "Ready to grow",
      enterprise: "Built for you",
    },
    plan_actions: {
      upgrade: "Upgrade",
      downgrade: "Downgrade",
      contact: "Contact us",
      active: "Active plan",
      unavailable: "Unavailable",
      processing: "Processing…",
    },
    plan_features: {
      free: {
        emails: "4,000 emails/month",
        additional_emails: "Additional emails unavailable",
        no_card: "No credit card required",
        retention: "7-day data retention",
        domains: "3 domains",
        senders: "1 sender",
        ip: "Shared IP",
        support: "Email support",
      },
      starter: {
        emails: "8,000 emails",
        additional_emails: "$1.00 per 1,000 additional emails",
        retention: "15-day data retention",
        domains: "5 domains",
        senders: "10 senders",
        ip: "Shared IP",
        support: "Priority support",
      },
      flow: {
        emails: "60,000 emails",
        additional_emails: "$0.90 per 1,000 additional emails",
        retention: "30-day data retention",
        domains: "15 domains",
        senders: "10 senders",
        ip: "Shared IP",
        support: "Priority support",
      },
      growth: {
        emails: "100,000 emails",
        additional_emails: "$0.75 per additional 1,000 emails",
        retention: "90-day data retention",
        domains: "100 domains",
        senders: "1,000 senders",
        ip: "Dedicated IP available as an add-on",
        support: "24/7 support",
      },
      enterprise: {
        volume_pricing: "Volume pricing",
        additional_emails: "Custom pricing for additional emails",
        domains: "Custom domains",
        senders: "Custom senders",
        sla: "SLA",
        onboarding: "Onboarding",
        consulting: "Consulting",
        ip: "Dedicated IP available as an add-on",
        support: "Dedicated Discord support",
      },
    },
  },
  button: {
    login: "Login",
    connect: "Log in",
    register: "Register",
    logout: "Logout",
    cancel: "Cancel",
    save: "Save",
    back: "Back",
    close: "Close",
  },
  error: {
    title: "Error",
    generic: "Something went wrong. Please try again.",
    connection: "The server could not be reached. Check your internet connection.",
    resource_not_found: "Error {statusCode}: Resource not found.",
    fetch_emails: "Error loading emails.",
  },
  user: {
    first_name: "First Name",
    last_name: "Last Name",
    email: "Email",
    password: "Password",
    password_confirmation: "Password Confirmation",
    error: {
      user_already_exist: "User already exists",
      passwords_do_not_match: "Passwords do not match",
      data_incomplete: "Please fill in all required fields",
      required: "This field is required",
    },
  },
  domain: {
    vercel: {
      description: "Connect your account to automatically add Postal records to Vercel DNS.",
      connected: "Vercel is connected to this team. Configure DNS from each domain's actions.",
      not_configured: "The OAuth integration needs to be configured by the Destinatarium administrator.",
      connect: "Connect Vercel",
      disconnect: "Disconnect Vercel",
      refresh: "Refresh",
      connection_success: "Vercel connected successfully.",
      disconnect_hint: "This team's connection will be removed from Destinatarium. DNS records will remain in Vercel. To also revoke authorization, uninstall Destinatarium from Integrations in Vercel.",
      configure_dns: "Configure DNS in Vercel",
      connect_first: "Connect Vercel to add Postal's DNS records.",
      loading_domains: "Checking Vercel domains…",
      domains_failed: "Domains could not be checked. Review the Vercel notice and click Refresh.",
      domain_unavailable: "The domain is not listed in the connected Vercel account. Check the selected team and click Refresh.",
      external_dns: "DNS hosted outside Vercel",
      choose_domain: "Choose a Vercel domain",
      manual_domain: "Enter another domain manually",
      preview_hint: "These are the current Postal records for zone {zone}. They will be checked again when applied.",
      conflict_hint: "There are incompatible records. Review the highlighted records in Vercel before continuing. SPF must have a single record; existing MX records may belong to your inbound email provider.",
      apply: "Add DNS records",
      applying: "Adding records…",
      result: "Created: {created}. Already present: {existing}.",
      propagation: "Changes need time to propagate. Use View DNS to check the status in Postal again.",
      partial: "The operation was interrupted. Close and reopen this window to refresh the state and retry missing records.",
      actions: { create: "Will be created", exists: "Already exists", conflict: "Conflict" },
      errors: {
        vercel_not_configured: "The Vercel integration has not been configured yet.",
        vercel_oauth_failed: "Authorization could not be completed. Connect Vercel again.",
        vercel_invalid_state: "Authorization expired, was already used or belongs to another user/team. Start connecting again from the correct team.",
        vercel_already_connected: "This Vercel installation is already linked to another Destinatarium team.",
        vercel_not_connected: "Connect Vercel before configuring DNS.",
        vercel_access_denied: "Vercel denied access. Check the integration's domain permissions or reconnect the account.",
        vercel_rate_limited: "Vercel's request limit was reached. Wait and try again.",
        vercel_not_found: "The resource is not available in the connected Vercel account.",
        vercel_domain_not_found: "The domain is not available in the connected Vercel account or team.",
        vercel_external_dns: "This domain does not use Vercel DNS. Configure records at its current DNS provider.",
        vercel_dns_conflict: "There are incompatible DNS records. Refresh the preview and review conflicts in Vercel.",
        vercel_request_failed: "The Vercel request could not be completed. Try again.",
        vercel_invalid_response: "Vercel returned an unexpected response. Try again.",
        vercel_pagination_limit: "This account exceeds the record lookup limit for one operation.",
        vercel_invalid_dns_record: "Postal returned a DNS record that cannot be added to Vercel.",
        vercel_no_dns_records: "A complete SPF and DKIM configuration was not received from Postal.",
      },
    },
    domains: "Domains",
    add_domain: "Add Domain",
    edit_domain: "Edit Domain",
    delete_domain: "Delete Domain",
    delete_confirm_title: "Delete domain?",
    delete_confirm_text: "{domain} will be removed from Destinatarium and Postal.",
    deleting: "Deleting...",
    domain_name: "Domain Name",
    domain_description: "Domain Description",
    domain_status: "Domain Status",
    domain_status_pending: "Pending",
    domain_status_approved: "Approved",
    domain_status_rejected: "Rejected",
    domain_status_error: "Error changing domain status",
    domain_list_empty: "No domains available",
    domain_list: "Domain List",
    domain: "Domain",
    empty_state: {
      title: "Add your first domain",
      description: "Connect a domain to verify it, configure its DNS, and start sending emails.",
      action: "Add my first domain",
    },
    view_dns: "View DNS Config",
    no_dns_info: "No DNS information is available.",
    error_fetching_dns: "Error loading DNS information.",
    domain_status_array: {
      pending: "Pending",
      pendingDNS: "Pending DNS",
      approved: "Approved",
    },
    success: {
      domain_added: "Domain added successfully",
      domain_deleted: "Domain deleted successfully",
    },
    error: {
      fetching_domains: "Error loading domains. Please try again.",
      fetching_domains_detail: "Error loading domains: {error}",
    },
    dns: {
      verification_status: "Verification status",
      ownership_verification: "Ownership verification",
      host: "Host",
      type: "Type",
      value: "Value",
      priority: "Priority",
      valid: "Valid",
      pending: "Pending",
      mx_records: "MX records",
      spf_record: "SPF record",
      dkim_record: "DKIM record",
      dmarc_record: "DMARC record",
      return_path: "Return path",
      copy_dkim: "Copy DKIM",
      optional: "Optional records",
      notes: "Notes",
      copy_json: "Copy JSON",
      copy_instructions: "Copy instructions",
      input_hint: "Enter the domain without http(s) or www.",
      notes_review_invalid: "Review records marked as invalid to complete the DNS configuration.",
      notes_rerun_verification: "After applying the DNS changes, run verification again.",
      notes_optional_mail: "Optional. Use this only when mail clients need mail.yourdomain for IMAP/SMTP.",
      notes_optional_autodiscover: "Optional. Automatic client configuration for Outlook and Thunderbird.",
      notes_optional_autoconfig: "Optional. Automatic mail client configuration.",
      notes_ptr: "Make sure the IP's PTR (reverse DNS) points to mail.krabbysystem.com.",
      notes_tls: "Use valid TLS certificates for mail.krabbysystem.com (Let's Encrypt).",
      notes_dmarc: "After validating delivery, you can raise DMARC to p=quarantine or p=reject.",
    },
  },
  api_keys: {
    help: {
      button: "How to use your key",
      title: "Using your API key",
      intro: "Connect your server to Destinatarium to send emails through the API.",
      send_only: "Your API key and the SDK only allow sending emails from your account. They do not allow data queries or access to Destinatarium administrative features.",
      examples_label: "Integration method",
      node_title: "Send with the Node.js SDK",
      node_install_step: "1. Install the SDK",
      node_requirements: "Requires Node.js 18 or later. Install the SDK in your server project:",
      copy_install: "Copy installation command",
      node_example_step: "2. Copy the example",
      node_hint: "Set the DESTINATARIUM_API_KEY environment variable on your server to your full key. Save this example as send-email.mjs and replace the sender with an address from your verified domain and the recipient with the destination address.",
      node_run_step: "3. Run the example",
      node_run_hint: "From your project folder, with the environment variable configured, run:",
      node_idempotency: "The SDK automatically adds Bearer authentication and an idempotency key for each send, preserving it across its retries to avoid duplicates.",
      node_docs: "View SDK documentation on npm",
      idempotency_title: "Optional idempotency: avoid duplicates when retrying",
      idempotency_hint: "The basic example works without this header. To retry a request, add Idempotency-Key with a unique identifier for that send. Keep the same identifier and payload when retrying; use a new one for another send.",
      create_step: "Create a key and copy its full value: it is only shown once. The masked key in the list cannot authenticate requests.",
      domain_step: "Add and verify the sender domain in Domains before sending.",
      auth_step: "Send the key in the header of each request:",
      example_title: "cURL example",
      example_hint: "Run this example from your server or terminal. Replace YOUR_API_KEY with your full key and change the sender and recipient. The sender must belong to your verified domain.",
      copy_example: "Copy example",
      example_copied: "Example copied.",
      response_title: "What does the response mean?",
      response_hint: "A successful response confirms the email was queued. Sending and delivery happen afterwards; check their status in Emails. It does not mean immediate delivery.",
      errors_title: "Common errors",
      error_401: "The key is missing, invalid or revoked.",
      error_403: "Check the key permissions and the sender's verified domain.",
      error_429: "A request or quota limit was reached; check the response and Retry-After when present.",
      security: "Store the key in a server environment variable. Do not include it in browser code or public repositories. If it is exposed, revoke it and create another.",
      example_subject: "Hello from Destinatarium",
      example_api_text: "Your first email using the API.",
      example_sdk_text: "Your first email using the SDK.",
    },
    title: "API keys",
    create: "Create API key",
    description: "Manage your API keys for programmatic access.",
    key: "API key",
    permissions: "Permissions",
    no_permissions: "No permissions",
    scope_labels: {
      emails_send: "Send emails",
      emails_read: "Read emails",
    },
    created_at: "Created at",
    actions: "Actions",
    revoke: "Revoke",
    revoking: "Revoking...",
    empty: "No API keys yet.",
    empty_state: {
      title: "Create your first API key",
      description: "Use an API key to connect your server and start sending emails securely.",
      action: "Create my first key",
    },
    new_key: "New API key (copy it now):",
    copy: "Copy API key",
    one_time_notice: "This value will not be shown again.",
    name: "Name",
    name_placeholder: "Production API",
    name_required: "Enter a name for the API key.",
    name_too_long: "The name cannot exceed 100 characters.",
    copy_error: "The API key could not be copied.",
    copy_success: "API key copied to clipboard.",
    revoke_title: "Revoke API key?",
    revoke_warning: "Applications using this key will immediately lose access.",
    revoked_success: "API key revoked.",
    errors: {
      name_exists: "An API key with this name already exists.",
      invalid_name: "The API key name must contain between 1 and 100 characters.",
      invalid_scopes: "The selected API key permissions are invalid.",
      invalid_request: "The API key request is invalid.",
    },
  },
  email: {
    email: "Email",
    emails: "Emails",
    add_email: "Add Email",
    edit_email: "Edit Email",
    delete_email: "Delete Email",
    email_from: "From",
    email_to: "To",
    email_cc: "CC",
    email_bcc: "BCC",
    email_reply_to: "Reply To",
    email_cc_hint: "CC recipients (optional)",
    email_bcc_hint: "BCC recipients (optional)",
    email_reply_to_hint: "Reply-to address (optional)",
    email_from_hint: "Supports the “Name <email{'@'}domain.com>” format",
    email_to_hint: "Supports the “Name <email{'@'}domain.com>” format or a comma-separated list",
    html_content: "HTML content",
    html_content_hint: "HTML content of the email",
    show_advanced: "Show advanced options",
    hide_advanced: "Hide advanced options",
    email_subject: "Subject",
    email_text: "Message (Text)",
    email_html: "HTML",
    email_status_str: "Status",
    email_status: {
      scheduled: "Scheduled",
      sending: "Sending",
      sent: "Sent",
      bounced: "Bounced",
      failed: "Failed",
      canceled: "Canceled",
      outcome_unknown: "Outcome unknown",
      suppressed: "Suppressed",
      delayed: "Delayed",
      delivered: "Delivered",
    },
    email_list_empty: "No emails available",
    email_list: "Email List",
    send_email: "Send Email",
    empty_state: {
      title: "Your first email is ready to go",
      description: "Once you send an email, you can follow its journey from here.",
      action: "Send my first email",
      help: "See how it works",
    },
    scheduled_at: "Scheduled at",
    schedule_delivery: "Schedule for later",
    delivery_date_time: "Delivery date and time",
    timezone: "Time zone",
    schedule_preview: "Exact delivery time",
    schedule_required: "Choose a delivery date and time.",
    invalid_schedule: "That local time does not exist in the selected time zone.",
    errors: {
      scheduled_at_in_past: "The delivery date and time must be later than the current time.",
    },
    detail: "Email Detail",
    detail_short: "Detail",
    breadcrumb_label: "Breadcrumb",
    no_subject: "No subject",
    copy_id: "Copy ID",
    copied: "Copied",
    copied_to_clipboard: "Copied to clipboard",
    copy_value: "Copy value",
    shipment_information: "Delivery information",
    email_journey: "Email journey",
    email_id: "Email ID",
    message_id: "Message ID",
    requested_by_api_key: "Requested with API key",
    domain: "Domain",
    size: "Size",
    format: "Format",
    technical_details: "Technical details",
    plain_text: "Plain text",
    preview_mode: "Preview format",
    html_preview_title: "Email HTML preview",
    event: "Event",
    event_recorded: "The event was recorded successfully.",
    retry: "Try again",
    detail_load_error: "We couldn't load this email",
    detail_load_error_hint: "Check your connection or try again in a moment.",
    events: "Events",
    attachments: "Attachments",
    no_attachments: "No attachments",
    inline: "Inline",
    download: "Download",
    attach_files: "Attach files",
    no_files_selected: "No files selected",
    files_selected: "{count} files selected",
    attachments_hint: "Up to 20 files and 40 MiB in Base64. Images: 5 MiB original and 400×400 px maximum.",
    inline_image: "Inline image",
    cid_hint: "Automatically inserted in the HTML as",
    remove_attachment: "Remove",
    too_many_attachments: "You can attach up to 20 files.",
    attachments_too_large: "Attachments exceed the 40 MiB Base64 limit.",
    empty_attachment: "Empty files cannot be attached.",
    attachment_read_error: "The attachment could not be read.",
    inline_attachment_error: "One or more inline email images could not be loaded.",
    image_too_large: "Each original image can be up to 5 MiB.",
    image_processing_error: "The image could not be resized or optimized.",
    image_dimensions_too_large: "This format cannot be resized automatically; use an image up to 400×400 px.",
    invalid_content_id: "Inline images need a unique, URL-safe content_id.",
    preview: "Email Preview",
    event_types: {
      sent: "Email Sent",
      delivered: "Delivered",
      bounced: "Bounced",
      opened: "Opened",
      clicked: "Link Clicked",
      unsubscribe: "Unsubscribed",
      complained: "Complained",
      canceled: "Canceled",
      delivery_delayed: "Delivery Delayed",
      failed: "Failed",
      scheduled: "Scheduled",
      processing: "Processing",
    },
    event_descriptions: {
      delivered: "The destination provider confirmed delivery.",
      sent: "The message was accepted for delivery.",
      processing: "The message was prepared successfully.",
      scheduled: "The message was scheduled for delivery.",
      opened: "The recipient opened the message.",
      clicked: "The recipient opened a link in the message.",
      bounced: "The destination server rejected the message.",
      failed: "Delivery could not be completed.",
      complained: "The recipient marked the message as spam.",
      unsubscribe: "The recipient requested to unsubscribe.",
      canceled: "Delivery was canceled.",
      delivery_delayed: "The provider temporarily delayed delivery.",
    },
    success: {
      send_email:
        "Your message has been queued and will be sent within the next few minutes",
    },
  },

  settings: {
    title: "Settings",
    usage: "Usage",
    billing: "Billing",
    profile: "Profile",
    team: "Global",
    team_section: {
      title: "Team settings",
      subtitle: "Set the default time zone used to schedule and display deliveries.",
      timezone: "Default time zone",
      timezone_hint: "Each delivery also stores its selected time zone for auditing.",
      save: "Save settings",
      saved: "The team time zone was updated successfully.",
    },
    billing_section: {
      title: "Billing",
      subtitle: "Review your plan, subscription status, and upcoming renewals.",
      plan: "Current plan",
      status: "Status",
      next_billing_date: "Next billing date",
      scheduled_change: "Scheduled change",
      opening: "Opening…",
      manage_in_paddle: "Manage billing in Paddle",
      free_plan_hint: "Payment methods and invoices will appear after you subscribe to a paid plan.",
      plan_fallback: "Plan {id}",
      statuses: {
        free: "Free",
        active: "Active",
        trialing: "Trialing",
        past_due: "Past due",
        paused: "Paused",
        canceled: "Canceled",
        cancelled: "Cancelled",
        unpaid: "Unpaid",
      },
      actions: {
        cancel: "Cancel",
        pause: "Pause",
        resume: "Resume",
      },
    },
    usage_section: {
      title: "Email usage",
      subtitle: "Track your team's allowance for the current billing period.",
      loading: "Loading current usage…",
      unavailable_title: "Usage is unavailable",
      unavailable_description:
        "We couldn't load your current allowance. Please try again.",
      retry: "Try again",
      quota_title: "Current email allowance",
      used_of: "{used} of {limit} emails used",
      percent_used: "{percent}% used",
      used: "Used",
      remaining: "Remaining",
      total: "Total allowance",
      billing_period: "Billing period",
      period_description: "Usage resets when this period ends.",
      starts: "Starts",
      resets: "Resets",
      allowance_breakdown: "Allowance breakdown",
      allowance_description:
        "Credits available to your team during this period.",
      source_plan: "Included with plan",
      source_credit_purchase: "Additional credits",
      source_promotion: "Promotional credits",
      source_manual: "Manual adjustment",
      source_other: "Other credits",
      not_configured_title: "Email allowance not configured",
      not_configured_description:
        "Your plan needs a custom email allowance before messages can be accepted.",
      manage_plan: "Manage plan",
    },
    profile_section: {
      title: "Profile",
      subtitle: "Update your personal information and password.",
      personal_info: "Personal Information",
      photo: "Profile photo",
      photo_hint: "JPG, PNG or WebP up to 2 MB.",
      choose_photo: "Choose photo",
      save_photo: "Save photo",
      remove_photo: "Remove photo",
      first_name_placeholder: "Your first name",
      last_name_placeholder: "Your last name",
      country_code: "Country code",
      phone: "Phone",
      change_password: "Change password",
      current_password: "Current password",
      new_password: "New password",
      repeat_new_password: "Repeat new password",
      password_hint: "At least 6 characters",
      repeat_password_hint: "Repeat the new password",
      language: "Language",
      language_hint: "This preference will be applied when you sign in on any device.",
      timezone: "Personal time zone",
      timezone_hint: "Used first when scheduling and displaying emails. You can inherit the team time zone.",
      use_team_timezone: "Use the team time zone",
      languages: {
        en: "English",
        es: "Spanish",
      },
      messages: {
        updated: "Profile updated",
        password_updated: "Password updated",
        fill_all_fields: "Please complete all fields",
        passwords_mismatch: "Passwords do not match",
        invalid_photo: "Choose a JPG, PNG or WebP image up to 2 MB.",
        photo_updated: "Profile photo updated",
        photo_removed: "Profile photo removed",
      },
    },
  },

  common: {
    saving: "Saving...",
    updating: "Updating...",
    logo_alt: "Destinatarium logo",
    avatar_alt: "Avatar",
  },
  // Agrega aquí más traducciones en inglés
};
